import Util from "@/helper/Utility.js";

export function SerialModel () {
    this.arrangedDate = null;
    this.campaignImgUrl = '';
    this.campaignName = '';
    this.campaignId = '';
    this.currentTimestamp = '';
    this.expireIn = '';
    this.privilegeMessage = '';
    this.privilegeMessageFormat = '';
    this.redeemTimestamp = '';
    this.redeemKey = '';
    this.serial = '';
    this.serialType = '';
    this.showTimer = false;

    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.setModelFromDataModel = function(campaign) {
        this.arrangedDate = campaign.arrangedDate || null;
        this.campaignImgUrl = campaign.fullImageUrl || '';
        this.campaignName = campaign.name || '';
        this.campaignId = campaign.id || '';
        this.expireIn = campaign.expireIn || 0;
        this.privilegeMessage = campaign.privilegeMessage || '';
        this.privilegeMessageFormat = campaign.privilegeMessageFormat | '';
        this.redeemTimestamp = campaign.redeemDate || '';
        this.redeemKey = campaign.redeemKey || '';
        this.serial = campaign.serial || '';
        this.serialType = campaign.barcode || '';
        if (Util.isNumber(campaign.minutesValidAfterUsed) && campaign.minutesValidAfterUsed > 0) {
            this.showTimer = true;
        }
    };
}
